export function resizeContainer(id = '', json = {}) {
    let jsonWithKey = Object.keys(json).length;
    if (typeof json === 'string') {
        jsonWithKey =
            json
                .replaceAll(/\s/g, '')
                .replaceAll('{', '')
                .replaceAll('}', '')
                .split('\n')
                .join().length > 0;
    }
    const editor = document.querySelector(`#${id} .ace-jsoneditor`);
    editor.style = `height: ${jsonWithKey ? '1000' : '0'}px; width: 100%; font-size: 14px;`;
}
